import React from 'react';

import NumberInput from "core/gd-modals/estimate-task/number-input";

export default function EstimateInputs(props) {
    return (
        <div className="form-line m-b-10 m-t-5">
            <div className="label ui5-txt-not-important-small">Custom</div>
            <div className="element custom-input">
                <NumberInput className="time" value={props.hours} postfix="h." onChange={props.onHoursChange} />
                :
                <NumberInput className="time" value={props.minutes} postfix="m." onChange={props.onMinutesChange} />
                <div className="ui5-button primary s30 m-l-10" onClick={props.onSave}>{props.saveLabel || 'Save'}</div>
            </div>
        </div>
    )
}